import React from "react";
import "./app.css";
import { getImage } from "../../../../../utils/getImages";
const LittleDreamersBannerPreview = ({ cardData, activetab }) => {
    const getBannerImage = () => {
        switch (activetab) {
            case "simplified_chinese":
                return cardData?.image1;
            case "treditonal_chinese":
                return cardData?.image2;
            case "bahasa":
                return cardData?.image;
            case "english":
            default:
                return cardData?.image;
        }
    };
    return (
    <div>
      <div className="card-body"></div>
      <div className="generic-banner">
        <div className="info">
          <img src={getImage(getBannerImage(cardData))} alt="Our Ship" className="w-100" />
          <div>
            <h3
              data-lang='{"CN":"您的郵輪⾸選"}'
              style={{ direction: activetab === "arabic" && "rtl" }}
            >
              {activetab === "english"
                ? cardData?.title
                : activetab === "simplified_chinese"
                ? cardData?.simplified_chinese_title
                : activetab === "arabic"
                ? cardData?.arabic_title
                : activetab === "bahasa"
                ? cardData?.bahasa_title
                : cardData?.traditional_chinese_title}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LittleDreamersBannerPreview;
